import { ReactElement } from 'react';
import VerticalLine from '@src/sld/components/Line/VerticalLine';
import Unit from './Unit';
import HorizontalLine from '@src/sld/components/Line/HorizontalLine';
import { UnitController, UnitControllerSN } from '../devicePointsConfig';
import { getDataPointsForUnitController } from '@src/sld/utils';

type A_UnitsProps = {
  unitControllersWithDataPointValues: UnitController[];
};

function A_Units(props: A_UnitsProps): ReactElement {
  const { unitControllersWithDataPointValues } = props;

  return (
    <>
      <HorizontalLine
        translateXCoordinate={330}
        translateYCoordinate={175}
        length={455}
        color='white'
        width={0.5}
      />

      <VerticalLine
        translateXCoordinate={330}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F1A1'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F1_A1,
        )}
        rectangleXCoordinate='295'
        rectangleYCoordinate='200'
        textStartingXCoordinate={300}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={425}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F1A2'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F1_A2,
        )}
        rectangleXCoordinate='385'
        rectangleYCoordinate='200'
        textStartingXCoordinate={390}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={515}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F1A3'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F1_A3,
        )}
        rectangleXCoordinate='475'
        rectangleYCoordinate='200'
        textStartingXCoordinate={480}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={605}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />

      <Unit
        label={'F1A4'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F1_A4,
        )}
        rectangleXCoordinate='565'
        rectangleYCoordinate='200'
        textStartingXCoordinate={570}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={695}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F1A5'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F1_A5,
        )}
        rectangleXCoordinate='655'
        rectangleYCoordinate='200'
        textStartingXCoordinate={660}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={785}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F1A6'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F1_A6,
        )}
        rectangleXCoordinate='745'
        rectangleYCoordinate='200'
        textStartingXCoordinate={750}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />
    </>
  );
}

export default A_Units;
